import i18n from 'helpers/i18n';
import messages from './messages';
import RouteHelpers from 'helpers/routes';
import lampIcon from 'images/reliabilityTest/lampIcon.svg';
import { TextLink } from '@teachstonellc/component-library';

function PassAttemptMessage({ trainerView = false }) {
  if (trainerView) {
    return <></>;
  }
  return (
    <div className="align-middle pt-4 mr-4">
      <div className="grid grid-col-2 gap-4">
        <div className="flex">
          <img src={lampIcon} className="self-start inline mr-4" alt="" />
          <div>
            {i18n.ft(messages.certificationPageBefore)}
            <TextLink
              className="underline [&>span]:font-[proxima-nova] [&>span]:text-ds-sm"
              href={RouteHelpers.getPath('certifications')}
            >
              {i18n.ft(messages.certificationPageLink)}
            </TextLink>
            {i18n.ft(messages.certificationPageAfter)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PassAttemptMessage;
